module.exports = __webpack_public_path__ + "img/Monaco.b996f79a.png";